import { CustomerMap, UnmappedCustomer } from '../../store/CustomerMap';
import { apiService } from '../APIService';
import { ApiAdvancedFilter, PaginatedResponse } from '../../store/GeneralStore';
import { buildAdvancedQueryURL } from '../../utils/helpers';
import { MergeRpmCustomerRecord } from '../../components/Pages/Data/Tabs/CustomerMap/CustomerMergeList';

const API_SERVER_URL = process.env.REACT_APP_API_SERVER_URL;

export const createCustomerMapData = (customerMapData: CustomerMap) => {
  return apiService.callExternalApi<CustomerMap>({
    url: `${API_SERVER_URL}/customer-maps`,
    method: 'POST',
    headers: {
      'content-type': 'application/json'
    },
    data: customerMapData
  });
};

export const deleteCustomerMapData = (id: number) => {
  return apiService.callExternalApi<void>({
    url: `${API_SERVER_URL}/customer-maps/${id}`,
    method: 'DELETE',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const updateCustomerMapData = (customerMapData: CustomerMap) => {
  return apiService.callExternalApi<CustomerMap>({
    url: `${API_SERVER_URL}/customer-maps/${customerMapData.customerId}`,
    method: 'PUT',
    headers: {
      'content-type': 'application/json'
    },
    data: customerMapData
  });
};

export const listCustomerMaps = (filters?: ApiAdvancedFilter) => {
  const mergedFilters: ApiAdvancedFilter = {
    page: 1,
    pageSize: 100,
    ...filters,
    orders: filters?.orders ?? [{ sort: 'sfdcCustomerName', direction: 'asc' }]
  };

  return apiService.callExternalApi<PaginatedResponse<CustomerMap>>({
    url: buildAdvancedQueryURL(mergedFilters, 'customer-maps'),
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const listUnmappedCustomers = (filters?: ApiAdvancedFilter) => {
  const mergedFilters: ApiAdvancedFilter = {
    page: 1,
    pageSize: 100,
    ...filters,
    orders: filters?.orders ?? [{ sort: 'id', direction: 'desc' }]
  };

  return apiService.callExternalApi<PaginatedResponse<UnmappedCustomer>>({
    url: buildAdvancedQueryURL(mergedFilters, 'customer-maps/unmapped'),
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const mergeCustomerList = () => {
  return apiService.callExternalApi<MergeRpmCustomerRecord[]>({
    url: `${API_SERVER_URL}/customer-maps/merge-customer-list`,
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};
